'use client';

import { FC } from 'react';
import { Button, Modal } from '@mui/material';
import { ModalWrapper } from '../QuickRequestModal/styled';
import { SendRequestForm, CrossIcon } from '@/components';

type SendRequestModalProps = {
  open: boolean;
  objectId: string;
  whatsappDisabled: boolean;
  hasInfoRequest: boolean;
  onClose: () => void;
  onComplete: () => void;
};

export const SendRequestModal: FC<SendRequestModalProps> = ({
  open,
  objectId,
  whatsappDisabled,
  hasInfoRequest,
  onClose,
  onComplete,
}) => {
  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <ModalWrapper>
        <Button variant="transparent" onClick={onClose} aria-label="Close">
          <CrossIcon aria-hidden="true" />
        </Button>
        {open && (
          <SendRequestForm
            objectId={objectId}
            whatsappDisabled={whatsappDisabled}
            hasInfoRequest={hasInfoRequest}
            onComplete={onComplete}
          />
        )}
      </ModalWrapper>
    </Modal>
  );
};
